import { ComponentType, type IConfig } from '../../types';
import { ComponentConfigType } from '../../utils/data-parser';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
  BASIC_TANSLATE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
  BASIC_VARIABLE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.Tooltip,
  configGroups: [
    {
      title: 'Component Properties',
      items: [
        {
          name: 'title',
          label: 'Title',
          valueComponent: {
            type: 'Input',
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.Translate,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.Translate,
              value: BASIC_TANSLATE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'titleCustomComponentSchema',
          label: 'Custom Title Component (overrides Title above if set)',
          valueComponent: {
            type: 'SubSchemaEditor',
            props: {
              schemaName: 'titleCustomComponentSchema',
              buttonText: 'Edit Title Component',
            },
          },
          configTypes: [],
          tooltips: [],
        },
        {
          name: 'visible',
          label: 'Visible',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
          ],
        },
        {
          name: 'placement',
          label: 'Placement',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Top', value: 'top' },
              { label: 'Top Left', value: 'topLeft' },
              { label: 'Top Right', value: 'topRight' },
              { label: 'Bottom', value: 'bottom' },
              { label: 'Bottom Left', value: 'bottomLeft' },
              { label: 'Bottom Right', value: 'bottomRight' },
              { label: 'Left', value: 'left' },
              { label: 'Left Top', value: 'leftTop' },
              { label: 'Left Bottom', value: 'leftBottom' },
              { label: 'Right', value: 'right' },
              { label: 'Right Top', value: 'rightTop' },
              { label: 'Right Bottom', value: 'rightBottom' },
            ],
            defaultValue: 'top',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'trigger',
          label: 'Trigger',
          valueComponent: {
            type: 'Select',
            mode: 'multiple',
            options: [
              { label: 'Hover', value: 'hover' },
              { label: 'Focus', value: 'focus' },
              { label: 'Click', value: 'click' },
              { label: 'Context Menu', value: 'contextMenu' },
            ],
            defaultValue: ['hover'],
          },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
          ],
        },
        {
          name: 'color',
          label: 'Color',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Default', value: '' },
              { label: 'Magenta', value: 'magenta' },
              { label: 'Red', value: 'red' },
              { label: 'Volcano', value: 'volcano' },
              { label: 'Orange', value: 'orange' },
              { label: 'Gold', value: 'gold' },
              { label: 'Lime', value: 'lime' },
              { label: 'Green', value: 'green' },
              { label: 'Cyan', value: 'cyan' },
              { label: 'Blue', value: 'blue' },
              { label: 'Geek Blue', value: 'geekblue' },
              { label: 'Purple', value: 'purple' },
            ],
            defaultValue: '',
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'arrow',
          label: 'Show Arrow',
          valueComponent: { type: 'Switch', defaultValue: true },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'zIndex',
          label: 'Z-Index',
          valueComponent: { type: 'InputNumber' },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
          ],
        },
      ],
    },
    {
      title: 'Overlay Root Style',
      component: 'CssSettings',
      props: { propsName: 'overlayRootStyle' },
    },
    {
      title: 'Overlay Content Style',
      component: 'CssSettings',
      props: { propsName: 'overlayBodyStyle' },
    },
  ],
};
